<template>
    <BasePanel 
        headline="lang_PUBLISHING_WORKS_CAPTION_OTHER_PERSONS"
        :alvqa="alvqa"
        :helpContext="getHelpContext"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="listItems"
                hide-default-footer
                :header-props="{ sortIcon: '' }"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
                :items-per-page="itemsPerPage"
            >
            <!-- TOP SLOT -->
                <template v-slot:top>
                    <v-row class="pb-3">
                        <v-spacer></v-spacer>
                        <v-col cols="3">
                            <BaseButton 
                                @click="addNewRow"
                                :disabled="$route.params.alvId === 'new'"
                                label="lang_GENERAL_BUTTON_ADD_ROW"
                                block
                                :alvqa="alvqa + '-button-add-row'"
                            />
                        </v-col>
                    </v-row>
                </template>

            <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

            <!-- Items -->
                <template v-slot:[`item.name`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-name'">
                        {{ item.name }}
                    </div>
                </template>
                <template v-slot:[`item.type`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-type'">
                        {{ $t(getType(item.type)) }}
                    </div>
                </template>

            <!-- Buttons -->
                <template v-slot:[`item.delete`]="{ item }">
                    <BaseIcon 
                        @click="deleteRow(item)"
                        icon="delete"
                        color="iconDelete"
                        tooltipText="lang_GENERIC_CAPTION_DELETE"
                        :alvqa="alvqa + 'list-row-icon-delete'"
                    />
                </template>
                <template v-slot:[`item.inlineEdit`]="{ item, index }">
                    <BaseIcon   
                        :alvqa="alvqa + '-list-row-icon-inline-edit'"
                        icon="edit" 
                        tooltipText="lang_GENERAL_CAPTION_ICON_EDIT"   
                        @click.stop="editInlineFunction(item, index)"
                    />
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import { DropdownPublishingWorksOtherPersonsTypes } from '@/assets/dropdowns/alvDropdowns.js'

import BasePanel from '@/components/_base/BasePanel'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseIcon from '@/components/_buttons/BaseIcon'

export default {
    name: "OtherPersonsEditPanel",
    components: {
        BasePanel,
        BaseButton,
        BaseIcon
    },
    data() {
        return {
            alvqa: 'publishing-works-edit-form-panel-other-persons'
        }
    },
    computed: {
        getHelpContext() {
            return 'PublishingWorksEditPanelOtherPersons'
        },
        headers() {
            return [
                {
                    text: this.$t("lang_CAPTION_NAME"), 
                    align: "left", 
                    value: "name",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-name'
                },
                {
                    text: this.$t("lang_PUBLISHING_WORKS_CAPTION_TYPE"), 
                    align: "left", 
                    value: "type",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-type'
                },
                {
                    text: '', 
                    value: 'inlineEdit',
                    align: 'right',
                    width: "70px",
                    class: 'text-no-wrap'
                },
                {
                    text: "",
                    align: "right",
                    width: "70px",
                    value: "delete",
                    class: 'text-no-wrap'
                }
            ]
        },

        listItems() { return this.$store.getters.getWorksOtherPersons },
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
    },
    methods: {
        getType(typeValue) {
            let types = DropdownPublishingWorksOtherPersonsTypes

            if(types !== undefined) {
                return types.find(type => {
                    return type.value === typeValue
                }).text
            }
        },

        addNewRow(){
            this.$store.commit('setShowWorksOtherPersonsEditingDialog', true)
            this.$store.commit('setEditingDialogHeadline', this.$t('lang_GENERAL_CAPTION_NEW_ENTRY'))

            let defaultValues = JSON.parse(JSON.stringify(this.$store.getters.getDefaultWorksOtherPersons)) 
            this.$store.commit('setWorksOtherPersonsEditingDialogDetails', defaultValues)
        },

        deleteRow(item) {
            // set the selected row that should be deleted from the delete action 
            // and open the deletion dialog
            this.$store.commit("setSelectedWorksOtherPersons", item)
            this.$store.commit('setDeletionDialogContext', 'SelectedWorksOtherPersons')
            this.$store.commit('setShowDeletionDialog', true)
        },

        editInlineFunction(item, index) {
            this.$store.commit('setSelectedWorksOtherPersons', index)
            let detailsDeepCopy = JSON.parse(JSON.stringify(item))

            // set the copy in dialog details to edit
            this.$store.commit('setWorksOtherPersonsEditingDialogDetails', detailsDeepCopy)
            this.$store.commit('setEditingDialogHeadline', this.$t("lang_GENERAL_CAPTION_EDITING_ENTRY")) // set headline
            this.$store.commit('setShowWorksOtherPersonsEditingDialog', true) 
        }
    },
    
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
        table-layout: fixed;
    }
</style>